import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-avatar2',
  templateUrl: './avatar2.component.html',
  styleUrls: ['./avatar2.component.less']
})
export class Avatar2Component implements OnInit {

  public avatarImage: string = '';
    public username: string = '';
    public imageSource = '';
    constructor(
        private authService: AuthService,
        private elRef: ElementRef,
        private router: Router
    ) { }

    ngOnInit() {
        this.imageSource = this.authService.getAvatarImage();
        this.username = this.authService.getUsername();
    }
    show() {
      // this.router.navigate(['createAvatar']);
    }


}
